import React from "react";
import {
  Paper,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Divider,
  Chip,
} from "@mui/material";
import {
  Receipt,
  Person,
  LocalShipping,
  Phone,
  LocationOn,
} from "@mui/icons-material";

const BottleOrderOverView = ({ bottleOrderData }) => {
  if (!bottleOrderData) {
    return (
      <Box sx={{ p: 3, textAlign: "center" }}>
        <Typography variant="body1" color="text.secondary">
          No bottle order data available
        </Typography>
      </Box>
    );
  }

  const InfoField = ({ label, value, icon: Icon }) => (
    <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
      {Icon && (
        <Icon
          sx={{
            color: "primary.main",
            fontSize: 20,
            mt: 0.3,
            opacity: 0.7,
          }}
        />
      )}
      <Box sx={{ flex: 1 }}>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: "block", mb: 0.5, fontWeight: 500 }}
        >
          {label}
        </Typography>
        <Typography variant="body2" sx={{ wordBreak: "break-word" }}>
          {value || "N/A"}
        </Typography>
      </Box>
    </Box>
  );

  return (
    <Paper elevation={0} sx={{ p: 3, bgcolor: "background.default" }}>
      <Box sx={{ mb: 3 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
          <Receipt sx={{ color: "primary.main", fontSize: 28 }} />
          <Typography variant="h5" component="h2" sx={{ fontWeight: 600 }}>
            Bottle Order Overview
          </Typography>
          {bottleOrderData.orderNumber && (
            <Chip
              label={`#${bottleOrderData.orderNumber}`}
              color="primary"
              size="small"
              sx={{ ml: 1, fontWeight: 600 }}
            />
          )}
        </Box>
      </Box>

      <Divider sx={{ mb: 3 }} />

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card variant="outlined" sx={{ bgcolor: "background.paper" }}>
            <CardContent>
              {/* Order Information Section */}
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ mb: 2, fontWeight: 600, textTransform: "uppercase" }}
              >
                Order Information
              </Typography>
              <Grid container spacing={2.5} sx={{ mb: 3 }}>
                <Grid item xs={12} sm={6} md={3}>
                  <InfoField
                    label="Order Number"
                    value={bottleOrderData.orderNumber}
                    icon={Receipt}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <InfoField
                    label="Account Number"
                    value={bottleOrderData.accountNumber}
                    icon={Receipt}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <InfoField
                    label="PO Number"
                    value={bottleOrderData.poNumber}
                    icon={Receipt}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <InfoField
                    label="Ordered By"
                    value={bottleOrderData.orderedBy}
                    icon={Person}
                  />
                </Grid>
              </Grid>

              <Divider sx={{ my: 3 }} />

              {/* Shipping Contact Section */}
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ mb: 2, fontWeight: 600, textTransform: "uppercase" }}
              >
                Shipping Contact
              </Typography>
              <Grid container spacing={2.5} sx={{ mb: 3 }}>
                <Grid item xs={12} sm={6} md={3}>
                  <InfoField
                    label="Shipping Name"
                    value={bottleOrderData.shippingName}
                    icon={LocalShipping}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <InfoField
                    label="Shipping Contact"
                    value={bottleOrderData.shippingContact}
                    icon={Person}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <InfoField
                    label="Shipping Phone"
                    value={bottleOrderData.shippingPhone}
                    icon={Phone}
                  />
                </Grid>
              </Grid>

              <Divider sx={{ my: 3 }} />

              {/* Shipping Address Section */}
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ mb: 2, fontWeight: 600, textTransform: "uppercase" }}
              >
                Shipping Address
              </Typography>
              <Grid container spacing={2.5}>
                <Grid item xs={12} sm={6} md={3}>
                  <InfoField
                    label="Address"
                    value={bottleOrderData.shippingAddress}
                    icon={LocationOn}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <InfoField
                    label="Address 2"
                    value={bottleOrderData.shippingAddress2}
                    icon={LocationOn}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <InfoField
                    label="City"
                    value={bottleOrderData.shippingCity}
                    icon={LocationOn}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <InfoField
                    label="State"
                    value={bottleOrderData.shippingState}
                    icon={LocationOn}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <InfoField
                    label="ZIP Code"
                    value={bottleOrderData.shippingZip}
                    icon={LocationOn}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default BottleOrderOverView;